export default __webpack_public_path__ + "static/uiux-0bd0f9f7584d7952ea38415fdd6aad13.png";